
import { defineComponent } from 'vue';
import loader from '@monaco-editor/loader';
import { editor } from 'monaco-editor';
import FileTreeExplorer from '../components/FileTreeExplorer.vue';
import { useCodeViewStore } from '../store';
import { ITreeFile, ITreeFolder, ITreeObject } from '@/codeGeneration/codeGen';
import { useGlobalStore } from '@/modules/globalModule/store';

let editorRef: editor.IStandaloneCodeEditor | null = null;
let monacoRef: any | null = null;
export default defineComponent({
  name: 'CodeViewPage',
  components: { FileTreeExplorer },
  data(): {
    store: any;
    openModel: { file: ITreeFile; model: editor.ITextModel } | null;
    openText: string;
  } {
    return {
      store: useCodeViewStore(),
      openModel: null,
      openText: ''
    };
  },
  mounted() {
    this.onMount();
    setTimeout(() => {
      this.openRouteFile();
    }, 250);
  },
  methods: {
    onMount() {
      const store = useCodeViewStore();
      loader.init().then((monaco): void => {
        const editorElem = document.getElementById('editor');
        if (editorElem) {
          editorRef = monaco.editor.create(editorElem, {
            language: 'python'
          });
        }
        monacoRef = monaco;
      });
      store.workspaceId = this.$route.params.workspaceId as string;
      store.loadCodeFromPersistance();
      const globalStore = useGlobalStore();
      if (!globalStore.workspaceId) {
        globalStore.loadWorkspace(store.workspaceId);
      }
    },
    openRouteFile() {
      const store = useCodeViewStore();
      if (this.$route.query.elemId && store.fileTreeRoot) {
        const fileToOpen = findFileFromElemId(
          store.fileTreeRoot,
          this.$route.query.elemId as string
        );
        if (fileToOpen) this.onFileOpened(fileToOpen);
      }
    },
    onFileOpened(file: ITreeFile, saveCurr: boolean = true) {
      if (
        !editorRef ||
        !monacoRef ||
        (this.openModel &&
          this.openModel.file.name === file.name &&
          this.openModel.file.elemId === file.elemId)
      )
        return;
      if (saveCurr) this.saveCurrentFile();
      // use prexisting model if possible
      // create new model if none found
      let modelInfo = {
        file: file,
        model: monacoRef.editor.createModel(file.data, file.language)
      };
      this.openModel = modelInfo;
      editorRef.setModel(modelInfo.model);
      this.openText = `open: ${file.name}`;
    },
    saveCurrentFile() {
      if (!this.openModel || !editorRef) return;
      const cvStore = useCodeViewStore();
      cvStore.saveCodeEditorFile(this.openModel.file, editorRef.getValue());
      this.openModel.file.data = editorRef.getValue();
      console;
    },
    goBack() {
      this.saveCurrentFile();
      this.$router.back();
    },
    openCanvas() {
      const globalStore = useGlobalStore();
      if (
        !this.openModel ||
        !this.openModel.file ||
        !this.openModel.file.elemId ||
        !globalStore.getElemPackage(this.openModel.file.elemId)
      ) {
        this.$router.push(`/packageCanvas/${this.$route.params.workspaceId}`);
        return;
      }
      const elemPackage = globalStore.getElemPackage(
        this.openModel.file.elemId
      );
      this.$router.push(
        `/nodesCanvas/${this.$route.params.workspaceId}/${elemPackage?.name}/${elemPackage?.id}`
      );
    }
  }
});
const findFileFromElemId = (
  fileTree: ITreeObject,
  elemId: string
): ITreeFile | undefined => {
  const fileTreeFile = fileTree as ITreeFile;
  const fileTreeFolder = fileTree as ITreeFolder;
  if (fileTreeFile.elemId && fileTreeFile.elemId === elemId) {
    return fileTreeFile;
  }
  if (fileTreeFolder.children) {
    for (const child of fileTreeFolder.children) {
      const file = findFileFromElemId(child, elemId);
      if (file) return file;
    }
  }
  return undefined;
};
